/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, OnDestroy, HostListener } from '@angular/core';
import { TimeClockShellViewService } from '../../view/time-clock-shell.view-service';
import { TimeClockShellComponentModel } from './time-clock-shell.component-model';

@Component({
  selector: 'app-time-clock-shell',
  templateUrl: './time-clock-shell.component.html',
  styleUrls: ['./time-clock-shell.component.scss'],
  providers: [TimeClockShellViewService],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeClockShellComponent implements OnInit, OnDestroy {

  constructor(private readonly viewService: TimeClockShellViewService) { }

  @HostListener('window:nfcTagDetected', ['$event'])
  nfcTagDetected(event) {
    this.viewService.viewModel.nfcKey = event.data.id;
  }

  ngOnInit() {
    this.viewService.initialize();
  }

  ngOnDestroy(): void {
    this.viewService.finalize();
  }

  get model(): TimeClockShellComponentModel {
    return this.viewService.componentModel;
  }

}
